export const CREATE_PAYOUT_ACCOUNT = `
mutation CreateCustomerPayoutAccount($accountNumber: String!, $accountType: String!, $bankBranchId: ID!, $customerId: ID!, $name: String!, $customerSubscriptionId: ID!, $isPayoutAccountVerified: Boolean) {
  createCustomerPayoutAccount(accountNumber: $accountNumber, accountType: $accountType, bankBranchId: $bankBranchId, customerId: $customerId, name: $name, customerSubscriptionId: $customerSubscriptionId, isPayoutAccountVerified: $isPayoutAccountVerified){
    customerPayoutAccount {
      id
      customer {
        id
        customerDebitAccounts {
          id
          name
          institutionName
          accountNumber
          accountType
          bankAccountType
          amount
          isVerified
          bankBranch {
            id
            name
            financialInstitution {
              id
              name
            }
          }
        }
        customerPayoutAccounts {
          id
          name
          institutionName
          accountNumber
          accountType
          isPayoutAccountVerified
          payoutAccountVerifiedAt
          customerSubscription{
            product{
              id
              name
            }
          }
          bankBranch {
            id
            name
            sortCode
            financialInstitution {
              id
              name
            }
          }
        }
      }
    }
    errors {
      property
      description
    }
  }
}`;

export const UPDATE_PAYOUT_ACCOUNT = `
mutation UpdateCustomerPayoutAccount($id:ID!, $accountNumber: String!, $accountType: String!, $bankBranchId: ID!, $customerId: ID!, $name: String!, $customerSubscriptionId: ID!, $isPayoutAccountVerified: Boolean) {
  updateCustomerPayoutAccount(id: $id, accountNumber: $accountNumber, accountType: $accountType, bankBranchId: $bankBranchId, customerId: $customerId, name: $name, customerSubscriptionId: $customerSubscriptionId, isPayoutAccountVerified: $isPayoutAccountVerified){
    customerPayoutAccount {
      id
      name
      customer {
        id
        customerDebitAccounts {
          id
          name
          isVerified
          institutionName
          accountNumber
          accountType
          bankAccountType
          amount
          bankBranch {
            id
            name
            financialInstitution {
              id
              name
            }
          }
        }
        customerPayoutAccounts {
          id
          name
          institutionName
          accountNumber
          accountType
          isPayoutAccountVerified
          payoutAccountVerifiedAt
          customerSubscription{
            product{
              id
              name
            }
          }
          bankBranch {
            id
            name
            sortCode
            financialInstitution {
              id
              name
            }
          }
        }
      }
    }
    errors {
      property
      description
    }
  }
}
`;

export const DELETE_PAYOUT_ACCOUNT = `
mutation DeleteCustomerPayoutAccount($id: ID!) {
  deleteCustomerPayoutAccount(id: $id){
    result
    errors {
      property
      description
    }
  }
}
`;

export const CREATE_DEBIT_ACCOUNT = `
mutation CreateCustomerDebitAccount($accountNumber: String!, $accountType: String!, $bankAccountType: String!, $bankBranchId: ID!, $amount: Float!, $customerId: ID!, $name: String!, $expirationDate: String!, $authorizationFormUrl: String, $customerSubscriptionId: ID!) {
  createCustomerDebitAccount(accountNumber: $accountNumber, accountType: $accountType, bankAccountType: $bankAccountType, bankBranchId: $bankBranchId, amount: $amount, customerId: $customerId, name: $name, expirationDate: $expirationDate, authorizationFormUrl: $authorizationFormUrl, customerSubscriptionId: $customerSubscriptionId){
    customerDebitAccount {
      id
      name
      customer {
        id
        customerDebitAccounts {
          id
          name
          isVerified
          institutionName
          accountNumber
          accountType
          bankAccountType
          amount
          expirationDate
          authorizationFormUrl
          bankBranch {
            id
            name
            financialInstitution {
              id
              name
            }
          }
        }
        customerPayoutAccounts {
          id
          institutionName
          accountNumber
          accountType
          bankBranch {
            id
            name
            financialInstitution {
              id
              name
            }
          }
        }
      }
    }
    errors {
      property
      description
    }
  }
}`;

export const UPDATE_DEBIT_ACCOUNT = `
mutation UpdateCustomerDebitAccount($id:ID!, $accountNumber: String!, $accountType: String!, $bankAccountType: String!, $bankBranchId: ID!, $amount: Float!, $customerId: ID!,  $name: String!, $expirationDate: String!, $authorizationFormUrl: String) {
  updateCustomerDebitAccount(id: $id, accountNumber: $accountNumber, accountType: $accountType, bankAccountType: $bankAccountType, bankBranchId: $bankBranchId, amount: $amount, customerId: $customerId, name: $name, expirationDate: $expirationDate, authorizationFormUrl: $authorizationFormUrl){
    customerDebitAccount {
      id
      name
      customer {
        id
        customerDebitAccounts {
          id
          name
          isVerified
          institutionName
          accountNumber
          accountType
          bankAccountType
          amount
          expirationDate
          authorizationFormUrl
          bankBranch {
            id
            name
            financialInstitution {
              id
              name
            }
          }
        }
        customerPayoutAccounts {
          id
          name
          institutionName
          accountNumber
          accountType
          bankBranch {
            id
            name
            financialInstitution {
              id
              name
            }
          }
        }
      }
    }
    errors {
      property
      description
    }
  }
}
`;

export const DELETE_DEBIT_ACCOUNT = `
mutation DeleteCustomerDebitAccount($id: ID!) {
  deleteCustomerDebitAccount(id: $id){
    result
    errors {
      property
      description
    }
  }
}
`;

export const VERIFY_PAYOUT_ACCOUNT = `
  query ValidatePayoutAccount($financialInstitutionId: ID!, $accountNumber: String!) {
    validatePayoutAccount(financialInstitutionId: $financialInstitutionId, accountNumber: $accountNumber) {
      status
      name
      message
    }
  }
`;

export const VALIDATE_PAYOUT_ACCOUNT_FUZZY_MATCH = `
  query ValidatePayoutAccountFuzzyMatch(
    $customerId: ID!
    $financialInstitutionId: ID!
    $accountNumber: String!
  ) {
    validatePayoutAccountFuzzyMatch(
      customerId: $customerId
      financialInstitutionId: $financialInstitutionId
      accountNumber: $accountNumber
    ) {
      status
      name
      score
      message
    }
  }
`;
